import getDomainFromLanguage from "./getDomainFromLanguage";

export default getDomainFromLanguage;
